import { useMemo } from 'react'
import { IslandApiResponse } from 'state/data/slice'

import { getPoolConfig } from '../'

export function usePoolConfiguration(poolApiResponse: IslandApiResponse | undefined, pool?: any) {
  const config = useMemo(() => {
    if (!poolApiResponse?.provider) return null
    return getPoolConfig(poolApiResponse.provider)
  }, [poolApiResponse?.provider])

  const poolData = useMemo(() => {
    if (!config || !poolApiResponse) return null
    return config.getPoolData(poolApiResponse, pool)
  }, [config, poolApiResponse])

  const metrics = useMemo(() => {
    if (!config || !poolApiResponse) return null
    return config.getPoolMetrics(poolApiResponse, pool)
  }, [config, poolApiResponse, pool])

  return {
    config,
    poolData,
    metrics,
  }
}
